(() => {
  if (customElements.get('tp-locale-selector')) return;
  const norm = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  class TpLocaleSelector extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      if (!this.dialog || !this.form) return;
      this.search = this.querySelector('[data-tp-search]');
      this.empty = this.querySelector('[data-tp-empty]');
      this.initialCountry = this.dataset.country;
      this.currentLang = this.dataset.lang;
      try { this.strings = JSON.parse(this.querySelector('[data-tp-strings]')?.textContent || '{}'); }
      catch (err) { this.strings = {}; }

      this.querySelector('[data-tp-open]')?.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-tp-close]').forEach((b) => b.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.reset());
      this.search?.addEventListener('input', () => this.filter());
      this.search?.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const first = this.form.querySelector('[data-tp-option]:not([hidden]) input');
        if (first) { first.checked = true; this.sync(first); first.focus(); }
      });
      this.form.addEventListener('change', (e) => this.sync(e.target));
      this.form.addEventListener('submit', (e) => this.submit(e));
    }

    checked(name) { return this.form.querySelector(`input[name="${name}"]:checked`); }

    open() {
      this.dialog.showModal();
      document.documentElement.classList.add('tp-locale-open');
      const c = this.checked('country_code');
      c?.closest('[data-tp-option]')?.scrollIntoView({ block: 'nearest' });
      if (this.search && window.matchMedia('(hover: hover)').matches) this.search.focus({ preventScroll: true });
      else (c || this.dialog.querySelector('[data-tp-close]'))?.focus({ preventScroll: true });
    }

    reset() {
      document.documentElement.classList.remove('tp-locale-open');
      this.form.reset();
      if (this.search) { this.search.value = ''; this.filter(); }
      this.hint();
      this.applyLang(this.currentLang);
    }

    // Swap the dialog's own UI text (title, labels, buttons) to the language the visitor has picked,
    // so the confirm button is readable before they commit. Country names stay as rendered.
    applyLang(code) {
      const s = this.strings[code];
      if (!s) return;
      this.dialog.setAttribute('lang', code);
      this.dialog.querySelectorAll('[data-tp-t]').forEach((el) => {
        const v = s[el.dataset.tpT];
        if (v != null) el.textContent = v;
      });
      this.dialog.querySelectorAll('[data-tp-ph]').forEach((el) => {
        const v = s[el.dataset.tpPh];
        if (v) { el.placeholder = v; el.setAttribute('aria-label', v); }
      });
      this.dialog.querySelectorAll('[data-tp-al]').forEach((el) => {
        const v = s[el.dataset.tpAl];
        if (v) el.setAttribute('aria-label', v);
      });
    }

    filter() {
      const q = norm(this.search.value.trim());
      let n = 0;
      this.form.querySelectorAll('[data-tp-option]').forEach((o) => {
        const show = !q || norm(o.dataset.name).includes(q);
        o.hidden = !show;
        if (show) n++;
      });
      this.form.querySelectorAll('[data-tp-group]').forEach((g) => { g.hidden = !g.querySelector('[data-tp-option]:not([hidden])'); });
      if (this.empty) this.empty.hidden = n > 0;
    }

    // Magyar exists only for Hungary; English works for every country.
    sync(t) {
      if (t.name === 'locale_code' && t.value === 'hu') {
        const hu = this.form.querySelector('input[name="country_code"][value="HU"]');
        if (hu) hu.checked = true;
      }
      if (t.name === 'country_code' && t.value !== 'HU') {
        const en = this.form.querySelector('input[name="locale_code"][value="en"]');
        if (en) en.checked = true;
      }
      this.hint();
      const lang = this.checked('locale_code');
      this.applyLang(lang ? lang.value : this.currentLang);
    }

    hint() {
      const lang = this.checked('locale_code');
      const showHu = lang && lang.value === 'hu' && this.initialCountry !== 'HU';
      this.form.querySelectorAll('[data-tp-hint="hu"]').forEach((h) => { h.hidden = !showHu; });
    }

    submit(e) {
      const lang = this.checked('locale_code');
      const country = this.checked('country_code');
      // Magyar chosen but Hungary is not in this domain's country list: go straight to trustpanda.hu.
      if (lang && lang.value === 'hu' && (!country || country.value !== 'HU')) {
        e.preventDefault();
        if (lang.dataset.href) window.location.href = lang.dataset.href;
        return;
      }
      if (!country) {
        e.preventDefault();
        if (this.search) this.search.focus();
        return;
      }
      if (country.value === this.initialCountry && (!lang || lang.value === this.currentLang)) {
        e.preventDefault();
        this.dialog.close();
      }
      // Otherwise submit country_code + locale_code; Shopify Markets redirects to the right domain and language.
    }
  }

  customElements.define('tp-locale-selector', TpLocaleSelector);
})();
